import { Collection } from "../ports.js";
const emptyMemory = (owner) => ({ owner, facts: {}, people: {}, asked: {}, counted: [] });
/** This owner's memory, or an empty one. Kept in the owner's own storage and keyed by them as well. */
export async function load(storage, owner) {
    return (await storage.get(Collection.memory, owner)) ?? emptyMemory(owner);
}
export function save(storage, doc) {
    return storage.put(Collection.memory, doc.owner, doc);
}
//# sourceMappingURL=store.js.map